export default function getDiscountReducer
    (state = {error: null, success: null, processing: false}, action) {

    switch (action.type) {
        case 'GET_DISCOUNT_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'GET_DISCOUNT_ERROR':
            return {...state, ...{error: action.error}};

        case 'GET_DISCOUNT_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default:
            return state;
    }
}